import React from 'react'
import { SupplierDetailFormAdminStyle } from './styled'
import {
  Button,
  Image,
  Input,
  Section,
  SelectBox,
  Switcher,
  InputTextarea,
  Modal,
} from '../../components'
import { ICONS } from '../../themes'
import {
  ROUTE_PATH,
  redirect,
  STRING,
  trimmedString,
  EMAIL_REGEX,
  toastActive,
} from '../../helpers'
import { Form, Formik } from 'formik'
import { supplierManagementController } from '../../apiService'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import { findId } from '../../helpers/functions/findIdUrl'
import { dateMonDayYearTime } from '../../helpers/functions/format'
import Header from './components/Header'
import ModalReject from './components/ModalReject'

export default class SupplierEditFormAdminContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      optionsCountry: [{ value: 'Thailand', label: 'Thailand' }],
      isEditPageState: true,
      isWaitingForActivateState: false,
      isWaitingForApprovalState: true,
      isActive: true,
      isRequested: true,
      modals: [
        // { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false },
        { name: 'rejectSupplier', isOpen: false },
        { name: 'accountStatus', isOpen: false },
      ],
      clickApproval: false,
      clickReject: false,
      verify: false,
      disableButton: false,
      isResendMailLoading: false,
      isVerifyLoading: false,
      detailFrom: {
        id: null,
        taxId: '',
        companyName: '',
        regAddress: '',
        regCountry: '',
        contactAddress: '',
        contactCountry: '',
        fullName: '',
        email: '',
        phone: '',
        approveStatus: '',
        fax: '',
        website: '',
        active: true,
        updateBy: '',
        updateDate: '',
      },
    }
  }

  componentDidMount() {
    this.showFormByAccountStatus()
    this.fetchSuppierByID()
  }

  initDetailForm = (
    values = {
      id: null,
      tax_id: '',
      company_name: '',
      regis_address: '',
      regis_country: '',
      contact_address: '',
      contact_country: '',
      supplier_full_name: '',
      supplier_email: '',
      supplier_phone: '',
      approve_status: null,
      status: null,
      update_by: '',
      update_date: '',
    }
  ) => {
    this.setState({
      detailFrom: {
        id: values.id,
        taxId: values.tax_id,
        companyName: values.company_name,
        regAddress: values.regis_address,
        regCountry: values.regis_country,
        contactAddress: values.contact_address,
        contactCountry: values.contact_country,
        fullName: values.supplier_full_name,
        email: values.supplier_email,
        phone: values.supplier_phone,
        approveStatus: values.approve_status,
        fax: values.fax || '',
        website: values.website || '',
        active: values.status === 1 ? true : false,
        updateBy: values.update_by,
        updateDate: values.update_date,
      },
    })
    const reject = values.approve_status === 4
    const approve = values.approve_status === 1
    if (reject) {
      this.goRejectPage(values.id)
    }
    if (approve) {
      this.setState({ clickApproval: true })
    }
  }

  showFormByAccountStatus = () => {
    const approveStatus =
      this.props.location.state && this.props.location.state.approveStatus
    switch (approveStatus) {
      case 1:
        this.setState({
          isWaitingForApprovalState: false,
          isWaitingForActivateState: false,
        })
        break
      case 2:
        this.setState({ isWaitingForApprovalState: true })
        break
      case 3:
        this.setState({ isWaitingForActivateState: true })
        break
      default:
        break
    }
  }

  goRejectPage = id => {
    this.props.history.push(
      ROUTE_PATH.SUPPLIER_DETAIL_FORM_ADMIN_REJECT.PATH + ':' + id
    )
  }

  goListSuppilerManagementPage = () => {
    setTimeout(
      this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK),
      3000
    )
  }

  fetchSuppierByID = async () => {
    try {
      const id = findId(window.location.pathname)
      const res = await supplierManagementController().getByID(id)
      const supplier = res && res.tax_id == null && res.result ? res.result : res
      if (supplier) {
        this.initDetailForm(supplier)
      }
    } catch (error) {
      throw ('fetchSuppierByID fail', error)
    }
  }

  onClickVerify = async formikActions => {
    if (!formikActions.values.taxId) {
      return formikActions.setErrors({ taxId: STRING.INVALID })
    }
    try {
      this.setState({ isVerifyLoading: true })
      const res = await supplierManagementController().verifyTaxID(
        formikActions.values.taxId
      )
      const companies = Array.isArray(res)
        ? res
        : res && Array.isArray(res.data)
        ? res.data
        : []
      const companyName =
        companies[0] && (companies[0].JP_TNAME || companies[0].JP_ENAME)
      if (companyName) {
        this.setState(prev => ({
          verify: true,
          isVerifyLoading: false,
          disableButton: false,
          detailFrom: {
            ...prev.detailFrom,
            ...formikActions.values,
            companyName,
          },
        }))
      } else {
        this.setState({
          verify: true,
          isVerifyLoading: false,
          disableButton: true,
        })
        formikActions.setErrors({ taxId: STRING.TAX_CHECK })
      }
    } catch (error) {
      throw new Error(error)
    }
  }

  updateSupplier = async (values, formikActions) => {
    if (
      values &&
      values.companyName &&
      values.fullName &&
      values.email &&
      values.phone &&
      values.taxId
    ) {
      const params = {
        supplier_id: values.id,
        tax_id: values.taxId,
        company_name: trimmedString(values.companyName),
        regis_address: trimmedString(values.regAddress),
        regis_country: trimmedString(values.regCountry),
        contact_address: trimmedString(values.contactAddress),
        contact_country: trimmedString(values.contactCountry),
        phone: trimmedString(values.phone),
        fax: trimmedString(values.fax),
        email: trimmedString(values.email),
        website: trimmedString(values.website),
        supplier_portal: '',
        admin_supplier_full_name: trimmedString(values.fullName),
        admin_supplier_email: trimmedString(values.email),
        admin_supplier_phone: trimmedString(values.phone),
        approve_status: parseInt(values.approveStatus),
        account_status: values.active ? 1 : 0,
      }
      const res = await supplierManagementController().updateSupplier(params)
      if (res) {
        this.setState({ isLoading: false })
        if (res.status === 'UpdateSuccess') {
          toastActive('Update was success')
          this.goListSuppilerManagementPage()
          setTimeout(formikActions.resetForm(), 3000)
        } else {
          toast.error(res.message)
        }
      }
    }
  }

  onClickResendMail = async (formikActions = '') => {
    if (!formikActions.values.email) {
      return formikActions.setErrors({ email: STRING.INVALID })
    }
    const emailFormatValid = !RegExp(EMAIL_REGEX).test(
      formikActions.values.email
    )
    if (emailFormatValid) {
      return formikActions.setErrors({ email: STRING.EMAIL_INVALID })
    }
    try {
      const params = {
        supplier_id: parseInt(formikActions.values.id),
        admin_supplier_email: formikActions.values.email,
      }
      this.setState({ isResendMailLoading: true })
      const res = await supplierManagementController().resendEmail(params)
      this.setState({ isResendMailLoading: false })

      if (res.status === 'EmailDuplicate') {
        return formikActions.setErrors({
          email: 'Email duplicate please change email',
        })
      }
      this.setState({ isResendMailLoading: false })
    } catch (error) {
      throw new Error('error', error)
    }
  }

  onSubmit = (values = {}, formikActions = () => {}) => {
    this.setState({ isLoading: true })
    if (values && formikActions) {
      this.updateSupplier(values, formikActions)
    }
  }

  onClickApproval = formikActions => {
    formikActions.setFieldValue('approveStatus', 1)
    this.setState({
      clickApproval: true,
    })
  }

  onClickConfirmReject = async () => {
    try {
      this.setState({ clickReject: true })
      this.supplierReject()
    } catch (error) {
      throw new Error('click reject', error)
    }
  }

  onClickCancel = () => {
    this.props.history.push(ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK)
  }

  onChangeTextArea = event => {
    this.setState({ reason: event.target.value })
  }

  handleInput = (formikActions = () => {}, e) => {
    const { name, value } = e.target
    formikActions.setFieldValue(name, value)
    formikActions.setErrors({ ...formikActions.errors, [name]: '' })
  }

  handleInputTaxId = (formikActions = () => {}, e) => {
    const { name, value } = e.target
    if (value !== formikActions.values.taxId) {
      formikActions.setFieldValue(name, value)
      formikActions.setErrors({ ...formikActions.errors, taxId: '' })
      this.setState({ disableButton: true, verify: false })
    }
  }

  handleStatusChange = (formikActions = () => {}, valueIsActive) => {
    formikActions.setFieldValue('active', !valueIsActive)
    if (valueIsActive) {
      this.toggleModal('accountStatus')
    }
  }

  onClickApproval = formikActions => {
    formikActions.setFieldValue('approveStatus', 1)
    this.setState({
      clickApproval: true,
    })
  }

  onClickConfirmAccountStatus = async () => {
    try {
      const params = {
        supplier_id: this.state.detailFrom.id,
        account_status: 0,
        reason: this.state.reason,
      }
      if (!this.state.reason) {
        this.setState({ errorReason: STRING.INVALID })
      } else {
        const res = await supplierManagementController().accountStatusInactive(
          params
        )
        if (res) {
          this.fetchSuppierByID()
          this.toggleModal('accountStatus')
        }
      }
    } catch (error) {
      throw new Error('account status inactive fail', error)
    }
  }

  supplierReject = async () => {
    try {
      const params = {
        supplier_id: this.state.detailFrom.id,
        approve_status: 2,
        reason: this.state.reason,
      }
      const res = await supplierManagementController().reject(params)
      if (res && res.status === 'UpdateSuccess') {
        this.fetchSuppierByID()
        this.setState({ disableTaxID: true, disableResendMail: true })
      } else {
        toast.error('Rejection was fail')
      }
    } catch (error) {
      throw error
    }
  }

  validateSchema = () => {
    const schema = Yup.object().shape({
      taxId: Yup.string().required(STRING.INVALID),
      fullName: Yup.string()
        .transform(fullName => trimmedString(fullName))
        .required(STRING.INVALID),
      email: Yup.string()
        .transform(email => trimmedString(email))
        .required(STRING.INVALID)
        .email(STRING.EMAIL_INVALID),
      phone: Yup.string()
        .transform(phoneValue => trimmedString(phoneValue))
        .required(STRING.INVALID),
    })
    return schema
  }

  toggleModal = evt => {
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
        })),
      }),
      () => {
        console.log(this.state.modals)
      }
    )
  }

  renderButtonApproveReject = formikProp => {
    const { clickApproval } = this.state
    if (clickApproval) {
      return (
        <Section className="form-group-inner-wrapper">
          {/* approved / rejected */}
          <span className={this.state.clickApproval ? 'approved' : 'rejected'}>
            {this.state.clickApproval ? 'Approved' : 'Rejected'} on{' '}
            {dateMonDayYearTime(formikProp.values.updateDate)} <br /> by{' '}
            {formikProp.values.updateBy}
          </span>
        </Section>
      )
    } else {
      return (
        <React.Fragment>
          <Section className="form-group-inner-wrapper">
            <Button
              className="theme-green"
              onClick={() => {
                this.onClickApproval(formikProp)
              }}
            >
              Approve
            </Button>

            <Button
              className="theme-border-gray"
              onClick={() => this.toggleModal('rejectSupplier')}
            >
              Reject
            </Button>
          </Section>

          <Section className="message"></Section>
        </React.Fragment>
      )
    }
  }

  render() {
    const {
      optionsCountry,
      isEditPageState,
      isWaitingForActivateState,
      isWaitingForApprovalState,
      isActive,
      isRequested,
      isVerifyLoading,
      modals,
      clickApproval,
    } = this.state
    const approveStatus =
      this.props.location.state && this.props.location.state.approveStatus
    const statusApprove = approveStatus === 1
    return (
      <React.Fragment>
        <SupplierDetailFormAdminStyle>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Header />

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Formik
            validationSchema={this.validateSchema}
            enableReinitialize={true}
            initialValues={this.state.detailFrom}
            validateOnBlur={true}
            validateOnChange={false}
            validateOnMount={false}
            // validate={values => this.validateStrEmpty(values)}
            onSubmit={(values, actions) => {
              this.onSubmit(values, actions)
            }}
          >
            {formikProp => {
              return (
                <React.Fragment>
                  <Section className="main-content form">
                    <Section className="content-body">
                      <Section className="form-wrapper">
                        <Section className="form-group-title">
                          {STRING.EDIT_SUPPLIER}
                        </Section>
                        <Form onSubmit={formikProp.handleSubmit}>
                          <Section
                            className={`form-group ${
                              formikProp.errors.taxId && 'is-error'
                            }`}
                          >
                            <label>Tax ID</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  name="taxId"
                                  value={formikProp.values.taxId}
                                  onChange={event =>
                                    this.handleInputTaxId(formikProp, event)
                                  }
                                  onBlur={formikProp.handleBlur('taxId')}
                                />
                                {clickApproval && (
                                  <Button
                                    disabled={this.state.verify ? true : false}
                                    className="theme-blue verify"
                                    onClick={() =>
                                      this.onClickVerify(formikProp)
                                    }
                                  >
                                    {!isVerifyLoading ? (
                                      'Verify'
                                    ) : (
                                      <span className="loader" />
                                    )}
                                  </Button>
                                )}
                              </Section>

                              <Section className="message">
                                {formikProp.errors.taxId}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.companyName && 'is-error'
                            }`}
                          >
                            <label>Company Name</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  disabled={true}
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  onBlur={formikProp.handleBlur('companyName')}
                                  value={formikProp.values.companyName}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.values.companyName}
                              </Section>
                            </Section>
                          </Section>

                          {!isWaitingForActivateState && (
                            <Section>
                              <Section className="form-col col-6">
                                <Section className="form-group-header">
                                  Registered Address
                                </Section>

                                <Section
                                  className={`form-group ${
                                    formikProp.errors.regAddress && 'is-error'
                                  }`}
                                >
                                  <label>Address</label>

                                  <Section className="form-group-control">
                                    <Section className="form-group-inner-wrapper">
                                      <InputTextarea
                                        disabled={true}
                                        onChange={event =>
                                          this.handleInput(formikProp, event)
                                        }
                                        onBlur={formikProp.handleBlur(
                                          'regAddress'
                                        )}
                                        name="regAddress"
                                        value={formikProp.values.regAddress}
                                      />
                                    </Section>

                                    <Section className="message">
                                      {formikProp.errors.regAddress}
                                    </Section>
                                  </Section>
                                </Section>

                                <Section
                                  className={`form-group ${
                                    formikProp.errors.regCountry && 'is-error'
                                  }`}
                                >
                                  <label>Country</label>

                                  <Section className="form-group-control">
                                    <Section className="form-group-inner-wrapper">
                                      <SelectBox
                                        id="active_status_filter"
                                        value={
                                          formikProp.values.regCountry
                                            ? {
                                                value: formikProp.values.regCountry,
                                                label: formikProp.values.regCountry,
                                              }
                                            : null
                                        }
                                        options={
                                          formikProp.values.regCountry
                                            ? [
                                                {
                                                  value: formikProp.values.regCountry,
                                                  label: formikProp.values.regCountry,
                                                },
                                              ]
                                            : optionsCountry
                                        }
                                        isSearchable={false}
                                        isClearable={false}
                                        isDisabled={true}
                                      />
                                    </Section>

                                    <Section className="message">
                                      {formikProp.errors.regCountry}
                                    </Section>
                                  </Section>
                                </Section>
                              </Section>

                              <Section className="form-col col-6">
                                <Section className="form-group-header grid-to-label">
                                  Contact Address
                                </Section>

                                <Section
                                  className={`form-group ${
                                    formikProp.errors.contactAddress &&
                                    'is-error'
                                  }`}
                                >
                                  <label>Address</label>

                                  <Section className="form-group-control">
                                    <Section className="form-group-inner-wrapper">
                                      <InputTextarea
                                        name="contactAddress"
                                        disabled={true}
                                        onChange={event =>
                                          this.handleInput(formikProp, event)
                                        }
                                        onBlur={formikProp.handleBlur(
                                          'contactAddress'
                                        )}
                                        value={formikProp.values.contactAddress}
                                      />
                                    </Section>

                                    <Section className="message">
                                      {formikProp.errors.contactAddress}
                                    </Section>
                                  </Section>
                                </Section>

                                <Section className={`form-group `}>
                                  <label>Country</label>

                                  <Section className="form-group-control">
                                    <Section className="form-group-inner-wrapper">
                                      <SelectBox
                                        id="contact_country_filter"
                                        value={
                                          formikProp.values.contactCountry
                                            ? {
                                                value: formikProp.values.contactCountry,
                                                label: formikProp.values.contactCountry,
                                              }
                                            : null
                                        }
                                        options={
                                          formikProp.values.contactCountry
                                            ? [
                                                {
                                                  value: formikProp.values.contactCountry,
                                                  label: formikProp.values.contactCountry,
                                                },
                                              ]
                                            : optionsCountry
                                        }
                                        isSearchable={false}
                                        isClearable={false}
                                        isDisabled={true}
                                      />
                                    </Section>

                                    <Section className="message"></Section>
                                  </Section>
                                </Section>
                              </Section>
                            </Section>
                          )}

                          <Section className="form-group-header">
                            Contact Person
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.fullName && 'is-error'
                            }`}
                          >
                            <label>Full name</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  disabled={
                                    formikProp.values.approveStatus === 2
                                  }
                                  type="text"
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  name="fullName"
                                  onBlur={formikProp.handleBlur('fullName')}
                                  value={formikProp.values.fullName}
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.fullName}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.email && 'is-error'
                            }`}
                          >
                            <label>Email</label>

                            <Section className="form-group-control with-button">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  disabled={
                                    formikProp.values.approveStatus === 2
                                  }
                                  type="text"
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  name="email"
                                  onBlur={formikProp.handleBlur('email')}
                                  value={formikProp.values.email}
                                />

                                {isEditPageState && (
                                  <Button
                                    className="theme-blue resend-activation-email"
                                    onClick={() =>
                                      this.onClickResendMail(formikProp)
                                    }
                                  >
                                    {!this.state.isResendMailLoading ? (
                                      'Resend Activation Email'
                                    ) : (
                                      <span className="loader" />
                                    )}
                                  </Button>
                                )}
                              </Section>

                              <Section className="message">
                                {formikProp.errors.email}
                              </Section>
                            </Section>
                          </Section>

                          <Section
                            className={`form-group ${
                              formikProp.errors.phone && 'is-error'
                            }`}
                          >
                            <label>Phone</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Input
                                  type="text"
                                  onChange={event =>
                                    this.handleInput(formikProp, event)
                                  }
                                  name="phone"
                                  onBlur={formikProp.handleBlur('phone')}
                                  value={formikProp.values.phone}
                                  disabled={
                                    formikProp.values.approveStatus === 2
                                  }
                                />
                              </Section>

                              <Section className="message">
                                {formikProp.errors.phone}
                              </Section>
                            </Section>
                          </Section>

                          {/* {isWaitingForApprovalState && ( */}
                          <Section className="form-group">
                            <label>Approve Status</label>

                            <Section className="form-group-control">
                              {this.renderButtonApproveReject(formikProp)}
                            </Section>
                          </Section>
                          {/* )} */}

                          {!isWaitingForApprovalState && (
                            <React.Fragment>
                              {/* <Section className="form-group sustainaility">
                              <label>
                                Sustainability <br />
                                Pre-Assessment <br />
                                Status
                              </label>

                              <Section className="form-group-control">
                                <Section className="form-group-inner-wrapper">
                                  {isRequested ? (
                                    <span>
                                      Request on 12/11/2019 14:20 by Mr.A
                                    </span>
                                  ) : (
                                    <React.Fragment>
                                      complete / incomplete
                                      <span className="incomplete">
                                        Incomplete
                                      </span>

                                      <Button className="theme-blue">
                                        Request
                                      </Button>
                                    </React.Fragment>
                                  )}
                                </Section>

                                <Section className="message"></Section>
                              </Section>
                            </Section> */}

                              {/* <Section className="form-group approve-status">
                              <label>Approve Status</label>

                              <Section className="form-group-control">
                                <Section className="form-group-inner-wrapper">
                                  approved / rejected
                                  <span className="approved">
                                    Approved on{' '}
                                    {dateMonDayYearTime(
                                      formikProp.values.updateDate
                                    )}{' '}
                                    <br /> by {formikProp.values.updateBy}
                                  </span>
                                </Section>

                                <Section className="message"></Section>
                              </Section>
                            </Section> */}
                            </React.Fragment>
                          )}

                          <Section className="form-group">
                            <label>Active</label>

                            <Section className="form-group-control">
                              <Section className="form-group-inner-wrapper">
                                <Switcher
                                  onChange={() =>
                                    this.handleStatusChange(
                                      formikProp,
                                      formikProp.values.active
                                    )
                                  }
                                  checked={formikProp.values.active}
                                  value={formikProp.values.active}
                                />
                              </Section>

                              <Section className="message"></Section>
                            </Section>
                          </Section>
                        </Form>
                      </Section>

                      <Section className="form-actions">
                        <Button
                          className="theme-border-gray"
                          onClick={() => this.onClickCancel()}
                        >
                          Cancel
                        </Button>

                        {!isWaitingForActivateState
                          ? isEditPageState && (
                              <Button
                                disabled={
                                  this.state.disableButton ? true : false
                                }
                                className="theme-green"
                                onClick={formikProp.handleSubmit}
                              >
                                Save
                              </Button>
                            )
                          : !isEditPageState && (
                              <Button className="theme-green">Save</Button>
                            )}

                        {isEditPageState && isWaitingForActivateState && (
                          <Button
                            className="theme-blue"
                            onClick={() => this.toggleModal('delete')}
                          >
                            Cancel Invite
                          </Button>
                        )}
                      </Section>
                    </Section>
                  </Section>
                  <ModalReject
                    headerTitle={
                      formikProp.values.active ? 'Active' : 'Inactive'
                    }
                    taxId={this.state.detailFrom.taxId}
                    companyName={this.state.detailFrom.companyName}
                    isOpen={
                      modals
                        .filter(modal => {
                          return modal.name === 'accountStatus'
                        })
                        .map(obj => obj.isOpen)[0]
                    }
                    toggleModal={() => this.toggleModal('accountStatus')}
                    onClickConfirm={this.onClickConfirmAccountStatus}
                    onChangeTextArea={this.onChangeTextArea}
                    valueTextArea={this.state.reason}
                  />
                  <ModalReject
                    headerTitle="Reject"
                    taxId={this.state.detailFrom.taxId}
                    companyName={this.state.detailFrom.companyName}
                    isOpen={
                      modals
                        .filter(modal => {
                          return modal.name === 'rejectSupplier'
                        })
                        .map(obj => obj.isOpen)[0]
                    }
                    toggleModal={() => this.toggleModal('rejectSupplier')}
                    onClickConfirm={this.onClickConfirmReject}
                    onChangeTextArea={this.onChangeTextArea}
                    valueTextArea={this.state.reason}
                  />
                </React.Fragment>
              )
            }}
          </Formik>
        </SupplierDetailFormAdminStyle>
      </React.Fragment>
    )
  }
}
